export default {
  swiper: {
    type: 'swiper',
    sliders: [
      {
        type: 'image',
        src: 'https://resource.gezishops.com/2/images/detail/KtIdsSr7HKgF8LNV0VUDVXAf1V1xDpREokREVXkM.jpeg',
        link: {}
      }
    ],
    style: {
      padding: 0,
      template: 'template1',
      margin_top: 0,
      display: 'block'
    }
  },
  images: {
    type: 'images', // 图片模块
    images: [
      {
        src: 'https://resource.gezishops.com/2/images/detail/KtIdsSr7HKgF8LNV0VUDVXAf1V1xDpREokREVXkM.jpeg',
        link: {}
      }
    ],
    style: {
      padding: 0,
      spacing: 0,
      template: 'template1',
      margin_top: 0,
      display: 'block'
    }
  },
  collapse: {
    type: 'collapse',
    title: '折叠面板',
    style: {
      padding: 0,
      margin_top: 0,
      collapse_number: 1,
      is_collapse: 0,
      display: 'block'
    }
  },
  richtext: {
    type: 'richtext',
    content: '',
    style: {
      padding: 0,
      margin_top: 0,
      display: 'block'
    }
  },
  videoPlayer: {
    type: 'videoPlayer',
    img_src: '/static/images/video.jpg',
    url: '',
    power: 1,
    style: {
      padding: 0,
      margin_top: 0,
      display: 'block'
    }
  },
  wtitle: {
    type: 'wtitle', // 标题
    title: 'MORE INFORMATION 作品详情',
    position: 'center',
    is_show_more: 0,
    more_text: '更多',
    style: {
      padding: 0,
      margin_top: 0,
      display: 'block'
    },
    link: { // 更多链接
    }
  },
  people: {
    type: 'people',
    headimg: 'https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3824570023,3239114142&fm=27&gp=0.jpg',
    name: '名称',
    describe: '这是一段描述',
    style: {
      padding: 0,
      margin_top: 0,
      display: 'block'
    }
  },
  description: {
    type: 'description',
    text: '这是一段描述',
    style: {
      padding: 0,
      margin_top: 0,
      display: 'block'
    }
  },
  movie: {
    type: 'movie',
    list: [],
    col: 2,
    style: {
      padding: 0,
      margin_top: 10,
      display: 'block'
    }
  },
  peopleDescribe: {
    type: 'peopleDescribe',
    title: '导 | 筒 | 专 | 访',
    image: '',
    text: '',
    style: {
      padding: 0,
      margin_top: 0,
      display: 'block'
    }
  },
  interview: {
    type: 'interview',
    title_left: '',
    title_right: '',
    direction: 'left',
    headimg: 'https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3824570023,3239114142&fm=27&gp=0.jpg',
    name: '名称',
    modules: [],
    style: {
      padding: 0,
      margin_top: 0,
      display: 'block'
    }
  },
  guest: {
    type: 'guest',
    title_left: '嘉宾',
    title_right: 'GUEST',
    thumb: '',
    thumb_title_left: '',
    thumb_title_right: '',
    text: '',
    style: {
      padding: 0,
      margin_top: 0,
      display: 'block'
    }
  },
  interviewVideo: {
    type: 'interviewVideo',
    thumb: '',
    src: '',
    text: '',
    style: {
      padding: 0,
      margin_top: 10,
      display: 'block'
    }
  },
  talkList: {
    title: '采访',
    type: 'talkList',
    list: [],
    style: {
      padding: 0,
      margin_top: 10,
      display: 'block'
    }
  },
  screeningList: {
    title: '放映',
    type: 'screeningList',
    list: [],
    style: {
      padding: 0,
      margin_top: 10,
      display: 'block'
    }
  },
  moviePanorama: {
    title: '展映',
    type: 'moviePanorama',
    list: [],
    style: {
      padding: 0,
      margin_top: 10,
      display: 'block'
    }
  },
  movieTrack: {
    title: '动态',
    type: 'movieTrack',
    list: [],
    style: {
      padding: 0,
      margin_top: 10,
      display: 'block'
    }
  },
  discussion: {
    title: '讲座',
    type: 'discussion',
    list: [],
    style: {
      padding: 0,
      margin_top: 10,
      display: 'block'
    }
  },
  topic: {
    title: '专题',
    type: 'topic',
    list: [],
    style: {
      padding: 0,
      margin_top: 10,
      display: 'block'
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/pageFormat.js